import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Catalogs|Other Requirements|Related Credentials|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

type LocNameStart = 'SPCatalogsOtherRequirementRelatedCreds';
export type SPCatalogsOtherRequirementRelatedCredsLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelStatus`
	| `${LocNameStart}LabelFilterByStatus`;

export const spCatalogsOtherRequirementRelatedCredsLocs: LocDefs<SPCatalogsOtherRequirementRelatedCredsLocNames> =
	{
		SPCatalogsOtherRequirementRelatedCredsTitlePage: {
			defaultValue: 'Related Credentials',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName:
				'OtherRequirement/Catalogs.OtherRequirementRelatedCredentials.Title.PageTitle',
			...sharedProperties,
		},
		SPCatalogsOtherRequirementRelatedCredsTitleTab: {
			defaultValue: 'Related Credentials',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName:
				'OtherRequirement/Catalogs.OtherRequirementRelatedCredentials.Title.TabTitle',
			...sharedProperties,
		},
		SPCatalogsOtherRequirementRelatedCredsLabelName: {
			defaultValue: 'Name',
			description: 'Column heading for: Name.',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName:
				'OtherRequirement/Catalogs.OtherRequirementRelatedCredentials.ColumnHeading.Name',
			...sharedProperties,
		},
		SPCatalogsOtherRequirementRelatedCredsLabelStatus: {
			defaultValue: 'Status',
			description: 'Column heading for: Status.',
			displayPath: `${pathStart}Status`,
			displayType: 'Label',
			legacyName:
				'OtherRequirement/Catalogs.OtherRequirementRelatedCredentials.ColumnHeading.Status',
			...sharedProperties,
		},
		SPCatalogsOtherRequirementRelatedCredsLabelFilterByStatus: {
			defaultValue: 'Filter by Status',
			description: 'Column heading for: Filter by Status.',
			displayPath: `${pathStart}Filter by Status`,
			displayType: 'Label',
			legacyName:
				'OtherRequirement/Catalogs.OtherRequirementRelatedCredentials.FieldLabel.FilterByStatus',
			...sharedProperties,
		},
	};

export type SPCatalogsOtherRequirementRelatedCredsLocType =
	LocMap<SPCatalogsOtherRequirementRelatedCredsLocNames>;
